import { useCallback } from 'react';
import { IVehicle, IAppointment } from '../API/GoMoto';
import { useLocale, useLocalization } from '../context/Localization/localization';
import { Locales } from '../context/Localization/localization.types';

export const DisplayMake = (vehicle: IVehicle | IAppointment) => ((vehicle.chromeMake ?? '').trim() === '' ? vehicle.make : vehicle.chromeMake) || '';

export const DisplayModel = (vehicle: IVehicle | IAppointment) => ((vehicle.chromeModel ?? '').trim() === '' ? vehicle.model : vehicle.chromeModel) || '';

export const useDisplayLocalizedVehicle = () => {
    const locale = useLocale();
    const Localization = useLocalization();

    return useCallback((vehicle: IVehicle | IAppointment, modelOnly: boolean = false) => {
        return Localization.formatString(
            locale === Locales.fr ? '{1} {0}' : '{0} {1}',
            `${vehicle.year ?? ''}`,
            modelOnly ? `${DisplayModel(vehicle)}` : `${DisplayMake(vehicle)} ${DisplayModel(vehicle)}`,
        ) as string || '';
    }, [Localization, locale]);
};